<template>
  <div style="height: 100vh">
    <page v-if="ready" />
    <div v-else class="loader">Loading...</div>
  </div>
</template>

<script>
import page from "@/components/page";
import { mapActions } from "vuex";
import { localize } from "vee-validate";
import colgate from "../store/colgate";
import { myHistory } from "../mixins/componentActions";

export default {
  data() {
    return {
      ready: false,
      meta: []
    };
  },
  components: {
    page
  },
  mounted() {
    // const url = window.location.host;
    // // const url = "always-testwochen.de";
    // let gdpr = "";

    // if (url == "always-testwochen.de") {
    //   gdpr = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";

    //   let script = document.createElement("script");
    //   script.setAttribute("type", "text/javascript");
    //   script.setAttribute("charset", "UTF-8");
    //   script.setAttribute("lang", "de");
    //   script.setAttribute("data-document-language", "true");
    //   script.setAttribute(
    //     "data-domain-script",
    //     "3d8b6c07-665f-4063-b360-02c843258464"
    //   );
    //   script.setAttribute("src", gdpr);
    //   document.head.appendChild(script);
    // }

    // if (url == "ariel-lenor-testwochen.de") {
    //   gdpr =
    //     "https://cdn.cookielaw.org/consent/0cdd9404-0dc3-433c-a226-1f301ac7fbaa.js";
    // }

    // this.addJsFile(gdpr);

    /**
     * Check the campaign ending date, and if its true,
     * redirect to 'campaign-is-over' page
     */
    // const endDate = new Date(this.$store.state.campaignEndDate).toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
    // const currentTime = new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
    // const dayInSeconds = 86400; // If we need to include the ending day
    // if ((new Date(endDate).getTime()/1000 + dayInSeconds) < (new Date(currentTime).getTime()/1000)) {
    //   this.goToPage('campaign-is-over', this)
    //   setTimeout(() => {
    //     window.location = '//headandshoulders.de'
    //   }, 300000)
    // }

    const self = this;
    history.pushState(myHistory, null, location.pathname + location.search);
    window.addEventListener("popstate", () => {
      if (myHistory.length > 0) {
        let page = "home";
        myHistory.length = 0;
        history.pushState(myHistory, null, page);

        self.skipPushState = true;
        colgate.pageProperties.testing =
          this.$store.state.pageProperties.testing;
        this.$store.replaceState(colgate);

        setTimeout(() => {
          this.goToPage(page, self);
        }, 10);
        self.skipPushState = false;
      } else {
        history.back();
      }
    });
  },
  created() {
    // const url = process.env.VUE_APP_SITE_URL || window.location.host;
    const pageProperties = this.$store.state.pageProperties;
    const dictionary = pageProperties.dictionary;
    if (dictionary) {
      // merges with built-in phrases
      localize(dictionary);
    }
    if (process.env.NODE_ENV === "development") {
      pageProperties.testing = true;
    } else {
      pageProperties.testing = false;
    }

    if (pageProperties == "GEOLIMIT") {
      this.$router.push("/geoLimit");
      // this.ready=true;
      return;
    }

    if (pageProperties == "NOT_FOUND" || !pageProperties.pages) {
      this.$router.push("/");
      // this.ready=true;
      return;
    }

    /**
     * Check if given url pathname is in pages database and its public,
     * otherwise redirect to error-page
     */
    const pathIsEmpty = this._.isEmpty(this.$route.params);
    if (!pathIsEmpty && this.$route.params) {
      const path = this.$route.params.pathMatch;
      this.isPublic(path).then(({ exist, isPublic }) => {
        if (isPublic) {
          this.goToPage(path, this);
        } else {
          history.replaceState({}, null, "/");
          if (exist) {
            colgate.pageProperties.testing =
              this.$store.state.pageProperties.testing;
            this.$store.replaceState(colgate);
          }
        }
        if (!exist) {
          // this.goToPage("error-page", this);
          if(this.$store.state.pageProperties.name === "promocolgatepalmolive") {
           this.goToPage("error-page", this);
          } else {
            this.goToPage(`${this.$store.state.pageProperties.url}/error-page`, this);
          }
        }
      });
    }
    if (pageProperties.header && pageProperties.header.properties.font) {
      this.addCssFile(pageProperties.header.properties.font.url);
      this.setGlobalFont(pageProperties.header.properties.font.name);
    }
    if (
      pageProperties.header &&
      pageProperties.header.properties.customJsInjection
    ) {
      const customJs = pageProperties.header.properties.customJsInjection;
      customJs.forEach((jsCfg) => {
        this.injectJs(jsCfg);
      });
    }
    if (pageProperties.header && pageProperties.header.properties.gdpr) {
      const gdprConfig = pageProperties.header.properties.gdpr;
      this.addJsFile(gdprConfig.url);
    }
    if (pageProperties.header && pageProperties.header.properties.dataLayer) {
      const GTMConfig = pageProperties.header.properties.dataLayer;
      //   this.addGTM(GTMConfig);
    }
    if (pageProperties.header && pageProperties.header.properties.neustar) {
      const neustarConfig = pageProperties.header.properties.neustar;
      this.addNeustar(neustarConfig);
    }
    if (
      pageProperties.header &&
      pageProperties.header.properties.facebookPixel
    ) {
      const facebookConfig = pageProperties.header.properties.facebookPixel;
      this.addFacebookPixel(facebookConfig);
    }

    if (pageProperties.header && pageProperties.header.properties.meta) {
      const meta = pageProperties.header.properties.meta;
      if (meta) {
        this.meta = meta;
      }
    }

    this.ready = true;
    document.dispatchEvent(new Event("x-app-rendered"));
    // });
  },
  methods: {
    ...mapActions(["isPublic"]),

    addCssFile(url) {
      const link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = url;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    addJsFile(url) {
      let script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("charset", "UTF-8");
      script.setAttribute("src", url);
      document.head.appendChild(script);
    },
    addHTML(html) {
      document.body.insertAdjacentHTML("beforeend", html);
    },
    setGlobalFont(font) {
      document.body.style.fontFamily = font;
    },
    addNeustar(cfg) {
      let N = document.createElement("script");
      N.setAttribute("type", "text/javascript");
      N.setAttribute("charset", "UTF-8");
      N.textContent = `   window.nsIdPending = false;
        function OptanonWrapper() {
          Optanon.OnConsentChanged(()=>{
          if(!window.nsId && !window.nsIdPending ){
              window.nsIdPending = true;
          fetchJsonp('${cfg.url}', {
                  jsonpCallbackFunction: 'neustar_response'
              })
              .then(function(response) {
                  return response.json()
              }).then(function(json) {
                  window.nsId = json.nsid
              })

          if (window._agknEchoTag) {
                  var a = window._agknEchoTag;
                  a.setBpId('firstp');
                  a.addEchoKeyValue('event', 'page_landing');
                  a.generateTag();
              }}
              })
      }`;
      document.head.appendChild(N);
    },
    injectJs(cfg) {
      let tag = document.createElement("script");
      tag.setAttribute("type", "text/javascript");
      tag.setAttribute("charset", "UTF-8");
      tag.textContent = cfg.content;
      if (cfg.location === "body") document.body.append(tag);
      else document.head.appendChild(tag);
      console.log("inject", tag);
    },
    addFacebookPixel(cfg) {
      let fbF = document.createElement("script");
      fbF.setAttribute("type", "text/javascript");
      fbF.setAttribute("charset", "UTF-8");
      fbF.textContent = `    !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${cfg.init}');
  fbq('track', 'PageView');
  `;
      document.head.appendChild(fbF);
      let fbNs = document.createElement("noscript");
      fbNs.textContent = `<img height="1" width="1" style="display:none" src="${cfg.noscript}"/>`;
      document.head.appendChild(fbNs);
    },
    addGTM(config) {
      const GTM = config.GTM;
      const GTM_CODE = config.GTM_CODE.toString();
      let GTM_TAG = document.createElement("script");
      GTM_TAG.setAttribute("type", "text/javascript");
      GTM_TAG.setAttribute("charset", "UTF-8");
      GTM_TAG.textContent = `const PGdataLayer ={'GTM':{'SiteLocalContainer':'${GTM.SiteLocalContainer}','FacebookRemarketingID':'${GTM.FacebookRemarketingID}','SiteLocale': 'ro-ro','SiteTouchpoint': '','SiteCountry': 'DE','SiteBrand': '','SiteLanguage': 'DE','SitePlatform': '','SiteEnvironment': 'Prod','SiteHost': 'CTL','SiteTechnicalAgency': 'Justsnap','SiteStatus': 'Live','GoogleAnalyticsLocal': '${GTM.GoogleAnalyticsLocal}','GoogleAnalyticsBrand': '','GoogleAnalyticsSiteSpeedSampleRate': 'high','GoogleAnalyticsAllowLinker': 'true','GoogleAnalyticsLinkerDomains': '','GoogleAnalyticsEnableOptimizely': 'false','GoogleAnalyticsConsentRequired': 'true','GoogleAnalyticsOptimizeContainerID': '','GoogleAnalyticsReportingView': '','GoogleReCaptcha': 'true', "ConsentOverlay": "${GTM.ConsentOverlay}", "ConsentOverlayID": "${GTM.ConsentOverlayID}","SitePrivacyProtection": "${GTM.SitePrivacyProtection}" }}`;
      let GTM_TAG_FN = document.createElement("script");
      GTM_TAG_FN.setAttribute("type", "text/javascript");
      GTM_TAG_FN.setAttribute("charset", "UTF-8");
      GTM_TAG_FN.textContent = `

       (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${GTM_CODE}');
      `;

      document.getElementsByTagName("head")[0].append(GTM_TAG);
      document.getElementsByTagName("head")[0].append(GTM_TAG_FN);
    }
  },
  metaInfo() {
    return {
      meta: this.meta
    };
  }
};
</script>
